<template>
  <div class="warp">
    <div class="warp-div flex">
      <div v-if="topList.length>0" class="top-pi flex-0" :style="'width:'+(topList.length>4?3*186:(topList.length-1)*186)+'px'" style="overflow: hidden;">
        <div class="ti flex flex-ac">
          <img class="img-sketch" src="@/assets/images/box/sketch.png" />
          <span>顶级掉落</span>
        </div>
        <ul class="ul-item flex">
          <li class="li-item flex-0 animate__animated animate__bounceInDown" v-for="(item,index) in topList" :key="index" :class="'move_style'+item.move_style+' '+parseColor(item)" @click="openbox(item.box_id)">
            <div class="info">
              <div class="imgurl-box flex-jc flex flex-ac">
                <img :src="item.imageUrl" alt="" class="imgurl">
              </div>
              <div class="label">{{ item.exteriorName }}</div>
              <div class="box-name__title p-1">{{ item.skin_name }}</div>
            </div>
            <div class="info-hover">
              <div>
                <div class="box-name__2">&nbsp;</div>
                <div class="player-name flex flex-ac flex-jc">
                  <img :src="item.player_img" alt="">
                  <span>{{ item.player_name }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="putong-pi flex-1" style="overflow: hidden;">
        <div class="ti flex flex-ac">
          <img class="img-sketch" src="@/assets/images/box/sketch.png" />
          <span>常规掉落</span>
        </div>
        <ul class="ul-item flex">
          <li class="li-item flex-0 animate__animated animate__bounceInDown" v-for="(item,index) in boxList" :class="'move_style'+item.move_style+' '+parseColor(item)" :key="index" @click="openbox(item.box_id)">
            <div class="info">
              <div class="imgurl-box flex-jc flex flex-ac">
                <img :src="item.imageUrl" alt="" class="imgurl">
              </div>
              <div class="label">{{ item.exteriorName }}</div>
              <div class="box-name__title p-1">{{ item.skin_name }}</div>
            </div>
            <div class="info-hover">
              <div>
                <div class="box-name__2">&nbsp;</div>
                <div class="player-name flex flex-ac flex-jc">
                  <img :src="item.player_img" alt="">
                  <span>{{ item.player_name }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { parseColor } from "@/assets/js/util.js";

export default {
  props: {
    boxId: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      parseColor,
      boxList: [],
      topList: [],
      newtOP: [],
      timer: '',
      transformY: 0
    };
  },
  watch: {},
  beforeDestroy() {
    this.websocketclose()
  },
  created() {
    this.getList()
    this.initWebSocket()
  },
  methods: {
    // parsePriceColor(item){
    //   if(50<item.price*1&& item.price*1 <200){
    //     return 'red-skin'
    //   }
    //   if(item.price*1>=200){
    //     return 'yellow-skin'
    //   }
    //   return ''
    // },
    openbox(box_id) {
      this.$router.push({
        path: `/index/Openbox`,
        query: {
          box_id: box_id,
        },
      });
    },
    getList() {
      if (localStorage.getItem("latelynew-" + this.type + '-1')) {
        this.boxList = JSON.parse(localStorage.getItem("latelynew-" + this.type + '-1'))
      } else {
        this.boxList = []
      }
      this.$doGet("/api/hall.Box/latelynew", {
        box_id: this.boxId,
        type: this.type,
        show: 1
      }).then((res) => {
        this.boxList = res.data
        this.boxList.map((item, index) => {
          item.move_style = index
        })
        localStorage.setItem("latelynew-" + this.type + '-1', JSON.stringify(this.boxList))
      }).catch(() => { })
      if (localStorage.getItem("latelynew-" + this.type + '-0')) {
        this.topList = JSON.parse(localStorage.getItem("latelynew-" + this.type + '-0'))
      } else {
        this.topList = []
      }
      this.$doGet("/api/hall.Box/latelynew", {
        box_id: this.boxId,
        type: this.type,
        show: 2
      }).then((res) => {
        this.topList = res.data
        this.topList.map((item, index) => {
          item.move_style = index
        })
        localStorage.setItem("latelynew-" + this.type + '-0', JSON.stringify(this.topList))
        // setInterval(() => {
        //   this.initTop(this.topList[1])
        // }, 2000)
      }).catch(() => { })
    },
    mouseenter() { },
    mouseout() { },

    //推送
    initWebSocket() {
      const domains = window.location.host.split('.')
      const wsuri = process.env.VUE_APP_WEBSOCKET == '' ? ('wss://api.' + domains[domains.length - 2] + '.' + domains[domains.length - 1] + '/ws') : process.env.VUE_APP_WEBSOCKET
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },

    websocketonopen() {
      //let actions = { test: "12345" };
      //this.websocketsend(JSON.stringify(actions));
    },

    websocketonerror() {
      // this.initWebSocket();
    },
    initBox(obj) {
      this.boxList.map((v, index) => {
        v.move_style = v.move_style * 1 + 1
        if (v.move_style == 12) {
          v.move_style = 0
          v.imageUrl = obj.img ? obj.img : obj.imageUrl
          v.exteriorName = obj.exteriorName
          v.skin_name = obj.skin_name
          v.box_name = obj.box_name
          v.player_img = obj.player_img
          v.player_name = obj.player_name
          v.color = obj.color
          v.rarity = obj.rarity
          v.price = obj.price
        }
      })
      this.$forceUpdate()
    },
    initTop(obj) {
      this.topList.map((v, index) => {
        v.move_style = v.move_style * 1 + 1
        if (v.move_style == 5) {
          v.move_style = 0
          v.imageUrl = obj.img ? obj.img : obj.imageUrl
          v.exteriorName = obj.exteriorName
          v.box_name = obj.box_name
          v.skin_name = obj.skin_name
          v.player_img = obj.player_img
          v.player_name = obj.player_name
          v.rarity = obj.rarity
          v.price = obj.price
        }
      })
      this.$forceUpdate()
    },
    websocketonmessage(d) {
      // console.log("接收:", JSON.parse(d.data))
      let messageData = JSON.parse(d.data)
      if (messageData.state == 'openBox') {
        let info = messageData.info.skins_info ? messageData.info.skins_info : []
        if (info.length == 0) {
          return false
        }
        for (let i = 0; i < info.length; i++) {
          if (info[i].top == 1) {
            this.initTop(info[i])
          } else {
            this.initBox(info[i])
          }
        }
      }
    },

    websocketsend(Data) {
      if (this.websock.readyState === WebSocket.OPEN) {
        this.websock.send(Data);
      }
    },

    websocketclose(e) {
      // console.log("close:", e);
    },
  }
};
</script>

<style lang="less" scoped>
.warp {
  margin: 0 auto;
  overflow: hidden;
  .ti {
    color: #fff;
    font-size: 14px;
    margin-bottom: 10px;
    img {
      width: 16px;
      height: auto;
      margin-right: 8px;
    }
  }
  .top-pi {
    // width: 558px;
  }
  .putong-pi {
  }
  .warp-div {
    // transform: translate(-2692px, 0px);
    overflow: hidden;
    width: 6697px;
    .ul-item {
      position: relative;
      height: 92px;
      width: 100%;
    }
    .li-item {
      transition: all 1s;
      width: 176px;
      height: 100%;
      cursor: pointer;
      background: url(~@/assets/images/skin/s_baby_blue.png) no-repeat;
      background-size: 100% 100%;
      position: absolute;
      left: 0;
      opacity: 0;
      // 这边是饰品颜色
      &.darkBlue-skin {
        background: url(~@/assets/images/skin/s_dark_blue.png) no-repeat;
        background-size: 100% 100%;
      }
      &.babyBlue-skin {
        background: url(~@/assets/images/skin/s_baby_blue.png) no-repeat;
        background-size: 100% 100%;
      }
      &.yellow-skin {
        background: url(~@/assets/images/skin/s_yellow.png) no-repeat;
        background-size: 100% 100%;
      }
      &.red-skin {
        background: url(~@/assets/images/skin/s_red.png) no-repeat;
        background-size: 100% 100%;
      }
      &.lavender-skin {
        background: url(~@/assets/images/skin/s_lavender.png) no-repeat;
        background-size: 100% 100%;
      }
      &.eggplant-skin {
        background: url(~@/assets/images/skin/s_eggplant.png) no-repeat;
        background-size: 100% 100%;
      }
      &.gray-skin {
        background: url(~@/assets/images/skin/s_gray.png) no-repeat;
        background-size: 100% 100%;
      }
      // 这边是移动的动画css
      &.move_style0 {
        left: -186px;
        z-index: 10;
        opacity: 0;
        transition: all 0s;
      }
      &.move_style1 {
        left: 0px;
        z-index: 9;
        opacity: 1;
      }
      &.move_style2 {
        left: 186px;
        z-index: 8;
        opacity: 1;
      }
      &.move_style3 {
        left: 372px;
        z-index: 7;
        opacity: 1;
      }
      &.move_style4 {
        left: 558px;
        z-index: 6;
        opacity: 1;
      }
      &.move_style5 {
        left: 744px;
        z-index: 5;
        opacity: 1;
      }
      &.move_style6 {
        left: 930px;
        z-index: 4;
        opacity: 1;
      }
      &.move_style7 {
        left: 1116px;
        z-index: 3;
        opacity: 1;
      }
      &.move_style8 {
        left: 1302px;
        z-index: 2;
        opacity: 1;
      }
      &.move_style9 {
        left: 1488px;
        z-index: 1;
        opacity: 1;
      }
      &.move_style10 {
        left: 1674px;
        opacity: 1;
      }
      &.move_style11 {
        left: 1860px;
        opacity: 1;
      }
      // &:nth-child(3n + 1) {
      //   background: url(~@/assets/images/box/slide-green.png) no-repeat;
      //   background-size: 100% 100%;
      // }
      // &:nth-child(3n + 2) {
      //   background: url(~@/assets/images/box/slide-g.png) no-repeat;
      //   background-size: 100% 100%;
      // }
      .info {
        width: 100%;
        height: 100%;
        display: block;
        .imgurl-box {
          width: 100%;
          overflow: hidden;
          height: 70px;
        }
        .imgurl {
          max-width: 100px;
          max-height: 60px;
          display: block;
          // margin: px auto;
        }
        .label {
          font-size: 12px;
          color: #ffc400;
          position: absolute;
          top: 6px;
          right: 6px;
        }
        .box-name__title {
          font-size: 12px;
          color: #fff;
          padding: 0 10px;
        }
      }
      .info-hover {
        width: 100%;
        height: 100%;
        display: none;
        overflow: hidden;
        padding-top: 18px;
        .box-name__2 {
          font-size: 16px;
          color: #fff;
          text-align: center;
        }
        .player-name {
          font-size: 14px;
          color: #fff;
          margin-top: 5px;
          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
      &:hover {
        .info {
          display: none;
        }
        .info-hover {
          display: block;
        }
      }
    }
  }
}
@media screen and (max-width: 1020px) {
  .top-pi {
    display: none;
  }
}
</style>
